import React from 'react'
import Button from 'react-bootstrap/esm/Button'
import Helpers from '../../Components/Helpers/Helpers'

const Encuesta1Form = ({ data }) => {
    return <>
        <Button variant='danger' size="sm" onClick={_ => {
            Helpers.print.construct({
                selector: '#frm_encuesta_detalle',
                title: 'Encuesta'
            })
        }}>
            <i className='fa fa-print mr-2'></i> Imprimir
        </Button>
        <div className='form-row' id="frm_encuesta_detalle">
            <div className="col-12">
                <div className="text-center mb-2">
                    <h6 className='text-primary'>
                        <strong>Calificación Final</strong>
                    </h6>
                </div>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Nombres</th>
                                <th>Edad</th>
                                <th>Puesto</th>
                                <th>Puntos</th>
                                <th>Calificación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='text-center'>
                                    {data.encuesta.name_user}
                                </td>
                                <td className='text-center'>
                                    {data.encuesta.age_user}
                                </td>
                                <td className='text-center'>
                                    {data.encuesta.job_user}
                                </td>
                                <td className='text-center'>
                                    {data.encuesta.points}
                                </td>
                                <td className='text-center'>
                                    <span className="badge" style={{
                                        background: data.encuesta.calification_color,
                                        color: data.encuesta.calification_color_text
                                    }}>{data.encuesta.calification}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="text-center mb-2">
                    <h6 className='text-primary'>
                        <strong>Calificación por Categoría</strong>
                    </h6>
                </div>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Categoría</th>
                                <th>Puntos</th>
                                <th>Calificación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {React.Children.toArray(data.questions.map((cat) => {
                                return <tr>
                                    <td className='text-center'>{cat.categoria}</td>
                                    <td className='text-center'>
                                        <strong>{cat.points_cat}</strong>
                                    </td>
                                    <td className='text-center'>
                                        <span className="badge" style={{
                                            background: cat.calification_cat_color,
                                            color: cat.calification_cat_color_text
                                        }}>{cat.calification_cat_text}</span>
                                    </td>
                                </tr>
                            }))}
                        </tbody>
                    </table>
                </div>

                <div className="text-center mb-2">
                    <h6 className='text-primary'>
                        <strong>Calificación por Dominio</strong>
                    </h6>
                </div>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Dominio</th>
                                <th>Puntos</th>
                                <th>Calificación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {React.Children.toArray(data.questions.map((cat) => {
                                return cat.dominios.map((dom) => {
                                    return <tr>
                                        <td className='text-center'>{dom.dominio}</td>
                                        <td className='text-center'>
                                            <strong>{dom.points_dom}</strong>
                                        </td>
                                        <td className='text-center'>
                                            <span className="badge" style={{
                                                background: dom.calification_dom_color,
                                                color: dom.calification_dom_color_text
                                            }}>{dom.calification_dom_text}</span>
                                        </td>
                                    </tr>
                                })
                            }))}
                        </tbody>
                    </table>
                </div>

                <div className="text-center mb-2">
                    <h6 className='text-primary'>
                        <strong>Grupos de ítems por dimensión, dominio y categoría</strong>
                    </h6>
                </div>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Categoría</th>
                                <th>Dominio</th>
                                <th>Dimensión</th>
                                <th>Preguntas</th>
                                <th>Acumulado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {React.Children.toArray(data.questions.map((cat) => {
                                return cat.dominios.map((dom) => {
                                    return dom.dimensiones.map((dim) => {
                                        return <tr>
                                            <td className='text-center'>{cat.categoria}</td>
                                            <td className='text-center'>{dom.dominio}</td>
                                            <td>{dim.dimension}</td>
                                            <td className='text-center'>{dim.preguntas.toString()}</td>
                                            <td className='text-center'>
                                                <strong>{cat.points_cat}</strong>
                                            </td>
                                        </tr>
                                    })
                                })
                            }))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </>
}

export default Encuesta1Form;